import { Trans } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import { UnstyledLink } from "@medoma/components/Link/Link";
import styles from "./AppSelector.module.scss";
import ArrowRightIcon from "@medoma/components/icons/ArrowRightIcon";

type IAppOption = {
  icon: React.ReactNode;
  label: string;
  description: string;
  to: string;
};

type IAppSelector = {
  primary: IAppOption;
  secondary: ReadonlyArray<IAppOption>;
};

export const AppSelector = ({ primary, secondary }: IAppSelector) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.intro}>
          <img className={styles.logo} src="/logo.svg" alt="Medoma" />
          <Heading level="h1" size="h1" className={styles.heading}>
            <Trans>Välkommen</Trans>
          </Heading>
        </header>

        <UnstyledLink to={primary.to} className={styles.primaryCard}>
          <span className={styles.primaryIconChip} aria-hidden>
            {primary.icon}
          </span>
          <span className={styles.primaryText}>
            <Heading level="h2" size="h2" className={styles.primaryLabel}>
              {primary.label}
            </Heading>
            <Text
              element="span"
              size="base"
              className={styles.primaryDescription}
            >
              {primary.description}
            </Text>
          </span>
          <span className={styles.primaryArrow} aria-hidden>
            <ArrowRightIcon />
          </span>
        </UnstyledLink>

        {secondary.length > 0 && (
          <section className={styles.secondarySection}>
            <ul className={styles.secondaryList}>
              {secondary.map((option) => (
                <li key={option.to}>
                  <UnstyledLink to={option.to} className={styles.secondaryItem}>
                    <span className={styles.secondaryIcon} aria-hidden>
                      {option.icon}
                    </span>
                    <Text
                      element="span"
                      weight="medium"
                      className={styles.secondaryTitle}
                    >
                      {option.label}
                    </Text>
                    <span className={styles.secondaryArrow} aria-hidden>
                      <ArrowRightIcon />
                    </span>
                    <Text
                      element="span"
                      size="small"
                      className={styles.secondaryDescription}
                    >
                      {option.description}
                    </Text>
                  </UnstyledLink>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>
    </div>
  );
};
